module.exports = __webpack_public_path__ + "img/personnel_access_feature_05.934bfc1a.jpg";